import TagPicker from './TagPicker';
export default TagPicker;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/ReportFilters/components/TagPicker/index.js